import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ContentDataService } from '@pages/info-center/services/content-data.service';

@Component({
  selector: 'app-terms-conditions',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, TranslateModule],
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss',
})
export class TermsConditionsComponent implements OnInit, OnDestroy {

  panelOpenState = false;
  termsConditions: any[] = [];
  termsConditions_main: any = [];
  termsConditionsLength = 0;
  isSkeletonTermsConditionsMain = true;

  private readonly isBrowser: boolean;
  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentDataService: ContentDataService,
    private sanitizer: DomSanitizer,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.contentDataService.getTermsConditions()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.termsConditions_main = res?.main_description?.length ? res.main_description[0].description : (res?.main_description ?? []);
        this.termsConditions = res?.contents?.rows ?? [];
        this.termsConditionsLength = this.termsConditions.length;
        this.isSkeletonTermsConditionsMain = false;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  scroll(id: string | number): void {
    if (!this.isBrowser) return;
    const el = document.getElementById(String(id));
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  sanitize(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content ?? '');
  }
}
